import React from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

// Collapsible Section Component
export const CollapsibleSection = ({ id, title, icon: Icon, expanded, toggle, children, defaultExpanded }) => {
  const isExpanded = expanded ?? defaultExpanded ?? false;

  return (
    <div className="border-b border-[#1e3a5f]/30 last:border-b-0">
      <button
        onClick={toggle}
        data-testid={`collapsible-toggle-${id}`}
        className="w-full p-3 flex items-center justify-between text-left hover:bg-[#1e3a5f]/10 transition-colors"
      >
        <div className="flex items-center gap-2">
          <Icon className="w-3.5 h-3.5 text-[#7dd3fc]" />
          <span className="text-[#7dd3fc] font-medium text-xs">{title}</span>
        </div>
        {isExpanded ? (
          <ChevronUp className="w-3.5 h-3.5 text-[#888680]" />
        ) : (
          <ChevronDown className="w-3.5 h-3.5 text-[#888680]" />
        )}
      </button>
      {isExpanded && (
        <div className="px-3 pb-3">
          {children}
        </div>
      )}
    </div>
  );
};
